import { useState, useEffect, useCallback } from 'react';
import { fetchFuelData } from './api';

export const useFuelData = () => {
  const [inventory, setInventory] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [todayStats, setTodayStats] = useState(null);
  const [aircraft, setAircraft] = useState([]);
  const [owners, setOwners] = useState([]);
  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchAll = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await fetchFuelData();
      setInventory(Array.isArray(data.inventory) ? data.inventory : []);
      setTransactions(Array.isArray(data.transactions) ? data.transactions : []);
      setTodayStats(data.todayStats);
      setAircraft(Array.isArray(data.aircraft) ? data.aircraft : []);
      setOwners(Array.isArray(data.owners) ? data.owners : []);
      setStaff(Array.isArray(data.staff) ? data.staff : []);
    } catch (err) {
      setError('Unable to load fuel data. Make sure the server is running.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAll();
  }, [fetchAll]);

  return {
    inventory,
    transactions,
    todayStats,
    aircraft,
    owners,
    staff,
    loading,
    error,
    fetchAll,
    setInventory,
    setTransactions,
    setTodayStats,
  };
};